import styles from "./app-switch.module.css"
import * as SwitchPrimitive from "@radix-ui/react-switch";
import * as React from "react";
import {cn} from "@/lib/utils";

export const AppSwitch = ({
                              className,
                              ...props
                          }: React.ComponentProps<typeof SwitchPrimitive.Root>) => {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(styles.Switch, className)}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    "pointer-events-none block transition-transform data-[state=checked]:translate-x-full data-[state=unchecked]:translate-x-0",
                    styles.Thumb
                )}
            />
        </SwitchPrimitive.Root>
    )
}
